/**
 * 配置说明
 * title: 跳转页面自动设置头部标题
 */
export default [
  {
    name: 'AgreementIndex',
    path: '/agreement/index',
    component: () =>
      import(
        /* webpackChunkName: "AgreementIndex" */
        '@/views/agreement/index'
      ),
    meta: { title: '协议中心' },
  },
  {
    name: 'AgreementPrivacy',
    path: '/agreement/privacy',
    component: () =>
      import(
        /* webpackChunkName: "AgreementPrivacy" */
        '@/views/agreement/privacy'
      ),
    meta: { title: '司机隐私政策' },
  },
  {
    name: 'AgreementPrivacyList',
    path: '/agreement/privacy-list',
    component: () =>
      import(
        /* webpackChunkName: "AgreementPrivacyList" */
        '@/views/agreement/privacy-list'
      ),
    meta: { title: '历史版本' },
  },
  {
    name: 'AgreementPrivacyCjj',
    path: '/agreement/privacy-cjj',
    component: () =>
      import(
        /* webpackChunkName: "AgreementPrivacyCjj" */
        '@/views/agreement/privacy-cjj'
      ),
    meta: { title: '车吉吉隐私政策' },
  },
  // {
  //   name: 'AgreementPersonalList',
  //   path: '/agreement/personal-list',
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "AgreementPersonalList" */
  //       '@/views/agreement/personal-list'
  //     ),
  //   meta: { title: '个人信息收集清单' },
  // },
  {
    name: 'AgreementThirdList',
    path: '/agreement/third-list',
    component: () =>
      import(
        /* webpackChunkName: "AgreementThirdList" */
        '@/views/agreement/third-list'
      ),
    meta: { title: '第三方共享清单' },
  },
  {
    name: 'FaceAgreement',
    path: '/agreement/faceAgreement',
    component: () =>
      import(
        /* webpackChunkName: "FaceAgreement" */
        '@/views/agreement/face-agreement'
      ),
    meta: { title: '人脸识别协议', style: 'navigation' },
  },
  {
    name: 'AgreementSoftware',
    path: '/agreement/software',
    component: () =>
      import(
        /* webpackChunkName: "AgreementSoftware" */
        '@/views/agreement/software'
      ),
    meta: { title: '网约车平台司机合作协议' },
  },
  {
    name: 'AgreementSoftwareList',
    path: '/agreement/software-list',
    component: () =>
      import(
        /* webpackChunkName: "AgreementSoftwareList" */
        '@/views/agreement/software-list'
      ),
    meta: { title: '历史版本' },
  },
  {
    name: 'SafeRules',
    path: '/agreement/safe-rules',
    component: () =>
      import(
        /* webpackChunkName: "SafeRules" */ '@/views/agreement/safe-rules'
      ),
    meta: { title: '平台安全规则' },
  },
  {
    name: 'AgreementMember',
    path: '/agreement/member',
    component: () =>
      import(
        /* webpackChunkName: "AgreementMember" */ '@/views/agreement/member'
      ),
    meta: { title: '小拉出行会员用户协议' },
  },
  {
    name: 'AgreementReduceMember',
    path: '/agreement/reduce-member',
    component: () =>
      import(
        /* webpackChunkName: "AgreementReduceMember" */ '@/views/agreement/reduce-member'
      ),
    meta: { title: '小拉出行减佣卡用户协议' },
  },
  {
    name: 'AgreementMemberAutoRenew',
    path: '/agreement/member-auto-renew',
    component: () =>
      import(
        /* webpackChunkName: "AgreementMemberAutoRenew" */ '@/views/agreement/member-auto-renew'
      ),
    meta: { title: '小拉出行会员自动续费服务协议' },
  },
  {
    name: 'AgreementReduceMemberAutoRenew',
    path: '/agreement/reduce-member-auto-renew',
    component: () =>
      import(
        /* webpackChunkName: "AgreementMemberAutoRenew" */ '@/views/agreement/reduce-member-auto-renew'
      ),
    meta: { title: '小拉出行减佣卡自动续费服务协议' },
  },
  {
    name: 'AgreementOnduty',
    path: '/agreement/onduty',
    component: () =>
      import(
        /* webpackChunkName: "AgreementOnduty" */ '@/views/agreement/onduty'
      ),
    meta: { title: '小拉出行出车验证协议' },
  },
  {
    name: 'IosSdk',
    path: '/agreement/ios-sdk',
    component: () =>
      import(/* webpackChunkName: "IosSdk" */ '@/views/agreement/ios-sdk.vue'),
    meta: { title: 'iOS-SDK目录' },
  },
  {
    name: 'AndroidSdk',
    path: '/agreement/android-sdk',
    component: () =>
      import(
        /* webpackChunkName: "AndroidSdk" */ '@/views/agreement/android-sdk.vue'
      ),
    meta: { title: 'Android-SDK目录' },
  },
  {
    name: 'AgreementPromise',
    path: '/agreement/promise',
    component: () =>
      import(
        /* webpackChunkName: "AgreementPromise" */ '@/views/agreement/promise.vue'
      ),
    meta: { title: '小拉平台准入承诺' },
  },
  {
    name: 'DeliveryGoods',
    path: '/agreement/delivery-goods',
    component: () =>
      import(
        /* webpackChunkName: "DeliveryGoods" */ '@/views/agreement/delivery-goods.vue'
      ),
    meta: { title: '小拉快送信息服务协议' },
  },
  {
    name: 'PersonInfoCollect',
    path: '/agreement/personal-list',
    component: () =>
      import(
        /* webpackChunkName: "PersonInfoCollect" */ '@/views/agreement/person-info-collect/index.vue'
      ),
    meta: { title: '个人信息收集清单' },
  },
  {
    name: 'LocationInfo',
    path: '/agreement/location-info',
    component: () =>
      import(
        /* webpackChunkName: "LocationInfo" */ '@/views/agreement/location-info/index.vue'
      ),
    meta: { title: '司机轨迹' },
  },
  {
    name: 'HllInfoShared',
    path: '/agreement/hll-info-shared',
    component: () =>
      import(
        /* webpackChunkName: "HllInfoShared" */ '@/views/agreement/hll-info-shared.vue'
      ),
    meta: { title: '信息共享授权小拉出行与“巨能装”协议' },
  },
  {
    name: 'JoinCommitment',
    path: '/agreement/join-commitment',
    component: () =>
      import(
        /* webpackChunkName: "JoinCommitment" */ '@/views/agreement/join-commitment.vue'
      ),
    meta: { title: '小拉平台准入承诺书' },
  },
  {
    name: 'HllPrivacy',
    path: '/agreement/hll-privacy',
    component: () =>
      import(
        /* webpackChunkName: "HllPrivacy" */ '@/views/agreement/hll-privacy.vue'
      ),
    meta: { title: '巨能装隐私协议' },
  },
  {
    name: 'HllInfoService',
    path: '/agreement/hll-info-service',
    component: () =>
      import(
        /* webpackChunkName: "HllInfoService" */ '@/views/agreement/hll-info-service.vue'
      ),
    meta: { title: '巨能装信息服务协议' },
  },
  {
    name: 'Common',
    path: '/agreement/common',
    component: () =>
      import(/* webpackChunkName: "Common" */ '@/views/agreement/common.vue'),
    meta: { title: '小拉出行' },
  },
  {
    name: 'ExclusiveServicePrivacy',
    path: '/agreement/exclusive-service-privacy',
    component: () =>
      import(
        /* webpackChunkName: "ExclusiveServicePrivacy" */ '@/views/agreement/exclusive-service-privacy.vue'
      ),
    meta: { title: '小拉独享信息服务协议' },
  },

  {
    name: 'ExclusivePrivacyPolicy',
    path: '/agreement/exclusive-privacy-policy',
    component: () =>
      import(
        /* webpackChunkName: "ExclusivePrivacyPolicy" */ '@/views/agreement/exclusive-privacy-policy.vue'
      ),
    meta: { title: '小拉独享隐私政策' },
  },
  /*
    历史版本-通用页
    拼接 historyKey 参数 ，展示对应协议的历史版本（https://coupe-v.xlcx.work/schema/228/dataList）
  */
  {
    name: 'AgreementHistoryList',
    path: '/agreement/history-list',
    component: () =>
      import(
        /* webpackChunkName: "AgreementHistoryList" */
        '@/views/agreement/history-list'
      ),
    meta: { title: '历史版本' },
  },
  /*
    隐私协议详情-通用页（支持历史版本）
    拼接 historyKey 参数 ，展示对应协议详情（https://coupe-v.xlcx.work/schema/228/dataList）
  */
  {
    name: 'Dynamic',
    path: '/agreement/dynamic',
    component: () =>
      import(/* webpackChunkName: "Dynamic" */ '@/views/agreement/dynamic.vue'),
    meta: { title: '小拉出行' },
  },
];
